"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const graphsource_1 = require("graphsource");
const Colors_1 = require("../Colors");
const vars_1 = require("../vars");
const theme_1 = require("../editor/theme");
exports.theme = Object.assign(Object.assign({}, graphsource_1.DefaultDiagramTheme), { fontFamily: vars_1.fontFamily, node: Object.assign(Object.assign({}, graphsource_1.DefaultDiagramTheme.node), { nameSize: 25, typeSize: 21, width: 280, spacing: Object.assign({}, graphsource_1.DefaultDiagramTheme.node.spacing) }), description: Object.assign({}, graphsource_1.DefaultDiagramTheme.description), help: Object.assign({}, graphsource_1.DefaultDiagramTheme.help), colors: {
        background: Colors_1.Colors.main[10],
        description: {
            background: Colors_1.Colors.main[9],
            text: Colors_1.Colors.pink[0],
        },
        minimap: {
            background: Colors_1.Colors.main[9],
            borders: Colors_1.Colors.pink[2],
            node: Colors_1.Colors.pink[4],
            visibleArea: Colors_1.Colors.main[8],
        },
        help: Object.assign({}, graphsource_1.DefaultDiagramTheme.colors.help),
        link: {
            main: Colors_1.Colors.pink[6],
            active: Colors_1.Colors.pink[0],
            hover: Colors_1.Colors.pink[0],
        },
        node: Object.assign(Object.assign({}, graphsource_1.DefaultDiagramTheme.colors.node), { background: Colors_1.Colors.main[9], type: Colors_1.Colors.grey[2], hover: {
                type: Colors_1.Colors.grey[0],
            }, selected: Colors_1.Colors.pink[0], types: theme_1.GraphQLColors, backgrounds: theme_1.GraphQLBackgrounds, options: {
                required: Colors_1.Colors.red[0],
                array: Colors_1.Colors.yellow[0],
            } }),
    } });
